import styled from 'styled-components';
import { ButtonRow } from '../Button';

export const FormButtonContainer = styled(ButtonRow)`
  width: 100%;
`;
